[
  {
    "id": "SIZE_1",
    "label": "1"
  },
  {
    "id": "SIZE_2_TO_10",
    "label": "2 - 10"
  },
  {
    "id": "SIZE_11_TO_50",
    "label": "11 - 50"
  },
  {
    "id": "SIZE_51_TO_200",
    "label": "51 - 200"
  },
  {
    "id": "SIZE_201_TO_500",
    "label": "201 - 500"
  },
  {
    "id": "SIZE_501_TO_1000",
    "label": "501 - 1000"
  },
  {
    "id": "SIZE_1001_TO_5000",
    "label": "1001 - 5000"
  },
  {
    "id": "SIZE_5001_TO_10000",
    "label": "5001 - 10000"
  },
  {
    "id": "SIZE_10001_OR_MORE",
    "label": "10001 or more"
  }
]
